/**
 * Comment attachment media helpers.
 * Backend has historically attached the AI-buddy avatar as comment mediaUrl
 * (including a misspelled filename). Prefer omitting those at map time rather
 * than substring-matching URLs in UI.
 */
export const COMMENT_ATTACHMENT_PLACEHOLDER_FILENAMES = [
  'AI_Buudy.png',
  'AI_Buddy.png',
] as const;

const normalizeMediaPath = (path: string): string =>
  path.trim().replace(/\\/g, '/').toLowerCase();

/** True when media path is a known non-attachment placeholder asset. */
export const isCommentAttachmentPlaceholder = (path?: string | null): boolean => {
  if (!path || typeof path !== 'string') return false;
  const normalized = normalizeMediaPath(path);
  return COMMENT_ATTACHMENT_PLACEHOLDER_FILENAMES.some((name) =>
    normalized.includes(name.toLowerCase()),
  );
};

/**
 * True when media is the same asset as the comment author's photo
 * (avatar incorrectly duplicated into mediaUrl).
 */
export const isCommentMediaSameAsAvatar = (
  mediaPath?: string | null,
  userPhoto?: string | null,
): boolean => {
  if (!mediaPath || !userPhoto) return false;
  const media = normalizeMediaPath(mediaPath).split('?')[0];
  const photo = normalizeMediaPath(userPhoto).split('?')[0];
  if (!media || !photo) return false;
  return media === photo || media.endsWith(photo) || photo.endsWith(media);
};
